import { GenericGrid } from '@amsanalytics/react-shared-library';
import { Card, CardHeader, CardTitle } from '@progress/kendo-react-layout';
import { Hint } from '@progress/kendo-react-labels';
import { IApplicationLeaseQuote } from '../../../../Interfaces/Application/IApplicationLeaseQuote';
import { getLeaseScheduleNote, getLeaseScheduleRows, LeaseScheduleRow } from '../../../../utils/leaseScheduleUtils';

export interface LeasePaymentScheduleDisplayProps {
  quote: IApplicationLeaseQuote | undefined;
  // The quote changed since its last Solve, so the rows are out of date.
  needsSolve: boolean;
  className?: string;
}

const columns = [
  { title: '#', field: 'paymentNumber', width: 60 },
  { title: 'Date', field: 'paymentDate', width: 110, format: '{0:d}' },
  { title: 'Payment', field: 'paymentAmount', width: 110, format: '{0:c}' },
  { title: 'Depreciation', field: 'depreciation', width: 110, format: '{0:c}' },
  { title: 'Rent Charge', field: 'rentCharge', width: 110, format: '{0:c}' },
  { title: 'Tax', field: 'tax', width: 100, format: '{0:c}' },
  { title: 'Balance After', field: 'balanceAfter', width: 120, format: '{0:c}' },
];

/** The solved lease quote's payment schedule; shown only while the quote has one. */
export default function LeasePaymentScheduleDisplay({ quote, needsSolve, className }: LeasePaymentScheduleDisplayProps) {
  const rows = getLeaseScheduleRows(quote);
  if (rows.length === 0) {
    return null;
  }
  const note = getLeaseScheduleNote(quote, rows);

  return (
    <Card className={className}>
      <CardHeader>
        <CardTitle>Amortization Schedule</CardTitle>
      </CardHeader>
      <div style={{ padding: '4px 8px' }}>
        {needsSolve ? (
          <Hint>Solve the lease quote to update the schedule.</Hint>
        ) : (
          <>
            <GenericGrid<LeaseScheduleRow>
              size={'small'}
              useIconButtons={true}
              columns={columns}
              items={rows}
              disableAdding={true}
              disableEditing={true}
              disableExcelExporting={true}
              disablePdfExporting={true}
              disableFiltering={true}
              disableGrouping={true}
              disablePaging={rows.length <= 20}
            />
            {note && <Hint>{note}</Hint>}
          </>
        )}
      </div>
    </Card>
  );
}
